module.exports = __webpack_public_path__ + "img/812-893f2a.png";